import type { HITLRendererProps } from '../HITLRenderer';
import { hitlStyles, cn } from './styles';

/**
 * CaptureRenderer stub for web app.
 * Screen capture is not available outside the Chrome extension.
 */
export const CaptureRenderer: React.FC<HITLRendererProps> = ({
  response,
  onSubmit,
  onCancel,
  isSubmitting,
  compact,
}) => {
  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    } else {
      onSubmit('cancel');
    }
  };

  return (
    <div className={cn(
      compact ? hitlStyles.containerCompact : hitlStyles.container,
      'bg-yellow-50 border-yellow-200'
    )}>
      <div className="flex items-center gap-3 mb-3">
        <span className="text-2xl">📸</span>
        <div>
          <h3 className="text-sm font-semibold text-gray-900">
            Capture non disponible
          </h3>
          <p className="text-xs text-gray-600">
            {response.message || 'La capture d\'écran n\'est pas disponible dans la version web.'}
          </p>
        </div>
      </div>

      <div className="flex gap-2">
        <button
          onClick={handleCancel}
          disabled={isSubmitting}
          className={cn(hitlStyles.actionButton, hitlStyles.actionButtonSecondary, 'w-full')}
        >
          Annuler
        </button>
      </div>
    </div>
  );
};
